// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.photos.RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest,
  RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details,
  RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_Path,
  RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AttestDigitallyAlteredPhotosRequestDto,
  DigitallyAlteredPhotosDetailsWebResponseDto,
  ListingAlias,
  SetDigitallyAlteredPhotoRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface DetailsParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest_Args {
  postData: AttestDigitallyAlteredPhotosRequestDto;
}

export type RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest_Args
>;

/**
 * Record that the user will mark digitally altered photos on a listing
 */
export const useRentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest_Args) =>
      RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_attest(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_Options = UseQueryOptions<
  DigitallyAlteredPhotosDetailsWebResponseDto,
  unknown,
  DigitallyAlteredPhotosDetailsWebResponseDto,
  readonly [string, DetailsParams]
>;

const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_Path, getParams] as const;

export const RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get whether digitally altered photos apply to a listing and if the attestation is done
 */
export const useRentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details.getKey =
  RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details_GetKey;

export interface RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set_Args {
  postData: SetDigitallyAlteredPhotoRequestDto;
}

export type RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set_Args
>;

/**
 * Mark a property photo as digitally altered or not; unmarking clears its original photo
 */
export const useRentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set_Args) =>
      RentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_set(args.postData, httpClient),
  });
};
